import { Component, ElementRef, Input, OnChanges, OnDestroy, OnInit, ViewChild } from '@angular/core';

@Component({
  selector: 'sc-countdown',
  templateUrl: './countdown.component.html',
  styleUrls: ['./countdown.component.scss'],
})
export class CountdownComponent implements OnChanges, OnDestroy {
  @ViewChild('countdownText') countdownText;
  @Input() countdown: number;
  @Input() color: string;
  @Input() shutter = false;

  countdownInterval: NodeJS.Timer;

  constructor(private elementRef: ElementRef) {}

  ngOnChanges(changes) {
    if (changes.countdown && changes.countdown.currentValue !== changes.countdown.previousValue) {
      this.togglePulseAnimation();
    }
    if (changes.color) {
      this.elementRef.nativeElement.style.setProperty('--color', changes.color.currentValue);
    }
  }

  ngOnDestroy() {}

  async togglePulseAnimation() {
    this.countdownText?.nativeElement.classList.add('pulse');
    await new Promise((resolve) => setTimeout(resolve, 200));
    this.countdownText?.nativeElement.classList.remove('pulse');
  }
}
